module.exports = __webpack_public_path__ + "img/banner.c8f6f376.png";